/**
 * Browser errors reported to Sentry, when the API's settings name a DSN (`errorReporting`). The
 * SDK is loaded only then, so the app's own bundle does not carry it. Errors React does not catch,
 * and errors no code handles, are reported. Nothing else is collected: no cookies, headers, query
 * parameters or user data.
 */

import type { RootOptions } from "react-dom/client";

import type { ErrorReporting } from "./config.js";

/** Starts reporting. The root options that report what React does not catch. */
export async function startErrorReporting(reporting: ErrorReporting): Promise<RootOptions> {
  const Sentry = await import("@sentry/react");
  Sentry.init({
    dsn: reporting.dsn,
    environment: reporting.environment,
    ...(reporting.release ? { release: reporting.release } : {}),
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
    },
  });
  const report = Sentry.reactErrorHandler();
  return {
    onUncaughtError: (error, errorInfo) =>
      report(error, { componentStack: errorInfo.componentStack ?? null }),
  };
}
